export default __webpack_public_path__ + "static/media/hamburgerMenu.606c1f9a.svg";